import { useEffect, useState } from "react";
import { Modal, Button as BsButton, Form } from "react-bootstrap";
import { InfoCircleFill } from "react-bootstrap-icons";
import { getMinCancelParkerDate } from "../Data/cancelParker";

interface CancelParkerModalProps {
  show: boolean;
  onHide: () => void;
  onConfirm: (cancellationDate: string) => void;
  defaultCancellationDate?: string;
  title?: string;
  message?: string;
  confirmLabel?: string;
}

export function CancelParkerModal({
  show,
  onHide,
  onConfirm,
  defaultCancellationDate,
  title = "Remove Parker",
  message = "Are you sure you want to remove this parker from your plan?",
  confirmLabel = "Confirm Cancellation",
}: CancelParkerModalProps) {
  const getDefaultDate = () => {
    const minDate = getMinCancelParkerDate();
    if (!defaultCancellationDate) return minDate;
    return defaultCancellationDate >= minDate ? defaultCancellationDate : minDate;
  };

  const [cancellationDate, setCancellationDate] = useState(getDefaultDate);
  const [cancelImmediately, setCancelImmediately] = useState(false);

  useEffect(() => {
    if (show) {
      setCancelImmediately(false);
      setCancellationDate(getDefaultDate());
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, defaultCancellationDate]);

  return (
    <Modal centered show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3">{message}</p>

        <div className="alert alert-muted-gold d-flex align-items-start gap-2 mb-3">
          <InfoCircleFill className="flex-shrink-0 mt-1" />
          <span>Access will continue through the end of the cancellation date.</span>
        </div>

        <Form.Check
          className="mb-3"
          type="checkbox"
          id="cancel-parker-immediately"
          label="Cancel immediately"
          checked={cancelImmediately}
          onChange={(e) => {
            const isChecked = e.target.checked;
            setCancelImmediately(isChecked);
            setCancellationDate(isChecked ? getMinCancelParkerDate() : getDefaultDate());
          }}
        />

        {!cancelImmediately && (
          <Form.Group className="mb-0">
            <Form.Label>Cancellation date</Form.Label>
            <Form.Control
              type="date"
              min={getMinCancelParkerDate()}
              value={cancellationDate}
              onChange={(e) => setCancellationDate(e.target.value)}
            />
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <BsButton variant="outline-secondary" onClick={onHide}>
          Go Back
        </BsButton>
        <BsButton
          variant="danger"
          disabled={!cancellationDate || cancellationDate < getMinCancelParkerDate()}
          onClick={() => {
            if (cancellationDate) onConfirm(cancellationDate);
          }}
        >
          {confirmLabel}
        </BsButton>
      </Modal.Footer>
    </Modal>
  );
}
